import styled from 'styled-components'

import { FIELD_HEIGHT } from './constants'

export const TextArea = styled.textarea`
  resize: none;
  overflow-y: hidden;
  min-height: ${FIELD_HEIGHT};
  border-radius: var(--input-border-radius);
  border: var(--input-border-width) solid var(--input-border-color);

  &:focus {
    outline: none !important;
  }

  &:focus-visible {
    border: var(--input-border-width) solid var(--blue-light) !important;
  }

  &::placeholder {
    color: var(--gray-700);
  }
`

export const InputCounter = styled.div`
  bottom: 1rem;
  right: 0;
  color: var(--gray-500);
  background-color: var(--dropdown-background-color);

  span {
    color: inherit;
    font-size: inherit;
  }
`
